module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKAgMAAADJO5Z1AAAAAXNSR0IB2cksfwAAAAlQTFRFAAAAAAAAAAAAg2PpwAAAAAN0Uk5TAGD/solA9AAAADNJREFUeJwVySEBACAQwMBhSIAiDXX4NIR4w6dkmBMbUVWXqUnXQ9MFYcaR2s04zLA/DHiMxRBuwF+rvwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/drop-down@2x.png
// module id = 812
// module chunks = 0